import React, { Component } from "react";
import Constants from "./Constants";
import Header from "./Header";
import Navbar from "./Navbar";
import { Helmet } from "react-helmet";

import Footer from "./Footer";
import { Link } from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";
import Axios from "axios";

export default class Batches extends Component {
  state = {
    batches: [],
    specification: {},
    data: "",
  };
  componentDidMount() {
    window.scrollTo(0, 0);
    // this.getbatches();
    let id = this.props.match.params.id;
    let data = this.props.location.state.name;

    console.log(this.props);
    Axios.get(Constants.getUrls.lablebycategory + id).then((res) => {
      console.log(res.data);
      this.setState({
        batches: res.data.batch,
        data,
      });
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      // alert("some");
      let id = this.props.match.params.id;
      let data = this.props.location.state.name;

      Axios.get(Constants.getUrls.lablebycategory + id).then((res) => {
        // console.log(res.data);
        this.setState({
          batches: res.data.batch,
          data,
        });
      });
    }
  }
  openModal(id) {
    // console.log(name);

    this.setState(
      {
        // visible : true,
        specification: this.state.batches.find((element) => element.id === id),
      },
      () => {
        console.log(this.state.specification);
      },
    );
  }

  closeModal() {
    this.setState({
      visible: false,
    });
  }
  render() {
    return (
      <div>
        <Helmet>
          <link
            rel="canonical"
            href={`https://www.vpaedu.com/batches/${
              this.props.match &&
              this.props.match.params &&
              this.props.match.params.id
                ? this.props.match.params.id
                : ""
            }`}
          />
          <title>
            {this.state.data.label === "CA"
              ? "Trusted CA Coaching in Nagpur – VPA Edu"
              : this.state.data.label === "CS"
              ? "Top CS Coaching Institute in Nagpur – VPA Edu"
              : this.state.data.label === "XI-XII CBSE"
              ? "VPA Edu | Leading 11th-12th CBSE Commerce Classes in Nagpur"
              : this.state.data.label === "XI-XII State Board"
              ? "VPA Edu | Leading 11th-12th State Board Commerce Classes in Nagpur"
              : "11th-12th State Board Commerce Classes in Nagpur – VPA Edu"}
          </title>
          <meta
            name="description"
            content={
              this.state.data.label === "CA"
                ? "Crack CA Foundation, CA Intermediate and CA Final with VPA Edu in Nagpur. Expert faculty, updated syllabus, study material, test series. Join now!"
                : this.state.data.label === "CS"
                ? "Start your CS-EET, CS Executive and CS Professional preparation at VPA Edu Nagpur with expert guidance, study material and test series. Enroll now!"
                : this.state.data.label === "XI-XII CBSE"
                ? "Excel in Std. 11th 12th CBSE Commerce with VPA Edu. Expert teaching in Accountancy, Mathematics, Business Studies, Economics, and English."
                : this.state.data.label === "XI-XII State Board"
                ? "VPA Edu offers expert 11th–12th State Board Commerce Classes in Nagpur for Accountancy, Maths, Economics, Secretarial Practices, OCM and English."
                : "VPA Edu offers expert 11th–12th State Board Commerce Classes in Nagpur for Accountancy, Maths, Economics, Secretarial Practices, OCM and English."
            }
          />
        </Helmet>
        <Header />
        <Navbar />
        <div className="breadcumb-area bg-img" style={{ position: "relative" }}>
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/7/77/Medlibrary.jpg"
            alt="Students studying together in a busy library reading room."
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: 0,
            }}
          />
          <div className="bradcumbContent">
            <h2>Batches</h2>
          </div>
        </div>
        {/* <ScrollAnimation
          animateIn="fadeInUp"
          animateOnce={true}
          animationInDuration={1800}
          isVisible={true}
        > */}
        <section className="ftco-section">
          {/* <h5
              style={{
                textAlign: "center",
                marginBottom: "40px",
                fontWeight: "bold",
                fontSize: "25px"
              }}
            >
              {this.state.data.label ? this.state.data.label : null}
            </h5> */}

          <div className="container-fluid px-4">
            <div className="row">
              {/* <h3>{this.state.data.label.name} </h3> */}

              {this.state.batches.map((singleCourse) => (
                <div
                  data-aos="zoom-in"
                  className="col-md-3 course "
                  style={{ marginBbottom: "60px", height: "450px" }}
                >
                  <div
                    className="single-top-popular-course"
                    style={{ padding: "15px" }}
                  >
                    <div className="img">
                      <img
                        alt={
                          this.state.data.label === "CA"
                            ? "Chartered Accountancy (CA) course overview with CA logo and exam details."
                            : this.state.data.label === "CS"
                            ? "Company Secretary (CS) course overview with CS logo and exam details."
                            : this.state.data.label === "XI-XII CBSE"
                            ? "Banner introducing Std. XI–XII CBSE Commerce classes"
                            : this.state.data.label === "XI-XII State Board"
                            ? "Banner introducing Std. XI–XII Maharashtra State Board Commerce classes"
                            : singleCourse.name || "Batch image"
                        }
                        src={Constants.imgUrl + singleCourse.image}
                        width="100%"
                      />
                    </div>
                    <div className="text pt-4">
                      <h3>{singleCourse.name}</h3>
                      <p>
                        {singleCourse.description
                          ? singleCourse.description
                          : "Description not available"}
                      </p>
                      <p>
                        {/* <b>Batch Tim :</b> {singleCourse.batch_time} */}
                      </p>
                      <section>
                        <Link
                          to={{
                            pathname: "/batchDetail",
                            state: {
                              name: singleCourse.name,
                              specification: singleCourse.specification,
                              batchtime: singleCourse.batch_time,
                              id: singleCourse.id,
                              file: singleCourse.file,
                            },
                          }}
                          className="btn download_btn"
                          onClick={() => this.openModal(singleCourse.id)}
                          style={{
                            padding: "12px",
                            fontWeight: "600",
                            color: "white",
                            margin: "0 40px",
                          }}
                        >
                          View / DownLoad
                        </Link>
                      </section>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        {/* </ScrollAnimation> */}

        <Footer />
      </div>
    );
  }
}
